import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

const INACTIVITY_LIMIT = 15 * 60 * 1000; // 15 mins
const WARNING_TIME = 60; // 60 seconds countdown

const SessionTimeout = () => {
  const navigate = useNavigate();

  const inactivityTimer = useRef(null);
  const countdownTimer = useRef(null);

  const [showWarning, setShowWarning] = useState(false);
  const [countdown, setCountdown] = useState(WARNING_TIME);

  const logout = () => {
    localStorage.clear();
    navigate("/login");
  };

  const resetInactivityTimer = () => {
    if (inactivityTimer.current) clearTimeout(inactivityTimer.current);
    if (countdownTimer.current) clearInterval(countdownTimer.current);

    setShowWarning(false);
    setCountdown(WARNING_TIME);

    inactivityTimer.current = setTimeout(() => {
      setShowWarning(true);
      startCountdown();
    }, INACTIVITY_LIMIT);
  };

  const startCountdown = () => {
    countdownTimer.current = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(countdownTimer.current);
          logout();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  useEffect(() => {
    const events = ["mousemove", "keydown", "click", "scroll"];

    events.forEach((event) =>
      window.addEventListener(event, resetInactivityTimer),
    );

    resetInactivityTimer();

    return () => {
      events.forEach((event) =>
        window.removeEventListener(event, resetInactivityTimer),
      );
      if (inactivityTimer.current) clearTimeout(inactivityTimer.current);
      if (countdownTimer.current) clearInterval(countdownTimer.current);
    };
  }, []);

  if (!showWarning) return null;

  return (
    <div style={overlayStyle}>
      <div style={modalStyle}>
        <h3>⚠ Session Expiring</h3>
        <p>
          You have been inactive. You will be logged out in{" "}
          <strong>{countdown}</strong> seconds.
        </p>
        <button onClick={resetInactivityTimer} style={buttonStyle}>
          Stay Logged In
        </button>
      </div>
    </div>
  );
};

const overlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  background: "rgba(0,0,0,0.6)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 9999,
};

const modalStyle = {
  background: "white",
  padding: "2rem",
  borderRadius: "12px",
  width: "400px",
  textAlign: "center",
};

const buttonStyle = {
  marginTop: "1rem",
  padding: "10px 20px",
  background: "#2563eb",
  color: "white",
  border: "none",
  borderRadius: "6px",
  cursor: "pointer",
};

export default SessionTimeout;
